export default "__VITE_ASSET__DSdDw1U0__"